import { createContext } from 'rax';
export const defaultContext = {
    labelAlign: 'top',
    labelWidth: 'auto',
    labelTextAlign: 'left',
    contentAlign: 'left',
    size: 'medium',
    isPreview: false,
    useLabelForErrorMessage: true,
    form: undefined,
    field: undefined,
};
export default createContext(defaultContext);
